import React, { useContext } from "react";
import HeaderInner from "../../Components/HeaderInner";
import Textheader from "../../Components/Textheader";
import Clientinfo from "../../Components/Clientinfo";
import Post1 from "../../assets/images/Spa/Post-3.png";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Gif from "../../assets/images/add-to-cart.gif";
import Title from "../../new-components/title/Title";
import NewFooter from "../../NewFooter";
import { ThemeContext } from "../../context/ThemeContext";
function HCOrderPlaced() {
  const { t, i18n } = useTranslation();
  // const new_design = localStorage.getItem("new_design");
  // const theme = new_design == "true";
  const { theme } = useContext(ThemeContext);
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const data = location.state?.metadata;
  const currency = localStorage.getItem("currency");

  console.log("location.state?.metadata", location.state?.metadata);
  return (
    <div className={theme ? "food" : ""}>
      {theme ? <Title title={"Order Details"} /> : <HeaderInner />}
      <main className="bg-white back-white pad-top-0 spa-order-placed">
        <div className="img-pnl">
          <img src={Gif} alt="Place Order" />
        </div>
        <h2 className="order-placed">{t("Your Booking is Confirmed")}</h2>
        <Clientinfo
          roomNumber={data.roomNumber}
          orderNumber={data.order_number}
          orderedAt={data.orderedAt}
        />

        <div className="full-heading grey-bg flex">
          <h2 className="blck co-header">{t("Order Details")} </h2>
        </div>
        <div className="full-div padd-div">
          <div className="booking-order-detail">
            <div className="img-pnl">
              <img
                src={data.order.image}
                alt="Spa"
                style={{
                  width: "100%",
                  height: "65px",
                  objectFit: "cover",
                  borderRadius: "10px",
                  boxShadow: "0px 3px 6px 0 rgb(0 0 0 / 16%)",
                }}
              />
            </div>
            <div className="txt-pnl">
              <p>{data.order.name}</p>
              <h3>
                {currency} {data.order.price}
              </h3>
            </div>
          </div>
        </div>
        <div className="spacer-40"></div>
        <div className="full-div padd-div text-center">
          <Link className="reg-btn large" to={`/${room_uuid}/qr-code`}>
            {t("Back to Home")}
          </Link>
        </div>
      </main>
      {theme && <NewFooter />}
    </div>
  );
}
export default HCOrderPlaced;
